import { isProdVersion } from '@stilingue/st-environment-controller-utils';

/**
 * Returns the appropriate passkey based on the environment (prod or staging)
 * @returns {string} The passkey for the current environment
 */
export const getPasskey = () => {
  return isProdVersion()
    ? 'bGVzc2lzbW9yZWxlc3Npc21vcmVsZXNzaXNtb3Jl'
    : '2NVHxvwK2dXNndUFUDmCDBiWro8ITelCiizo6C0D';
};
